import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "homeimgwrap"
};
const _hoisted_3 = {
  class: "homeimg"
};
const _hoisted_4 = {
  class: "homeaboutwrap"
};
const _hoisted_5 = {
  class: "homeabout"
};
const _hoisted_6 = {
  class: "homeaboutimg"
};
const _hoisted_7 = {
  class: "hoemaboutinfo"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", {
  class: "linetitleright"
}, "企业简介", -1);
const _hoisted_9 = {
  class: "linesubtitle"
};
const _hoisted_10 = {
  class: "content1"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dd", {
  class: "linkmoreright"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/about",
  class: "navmore"
}, "了解更多")], -1);
const _hoisted_12 = {
  class: "homesoluwrap"
};
const _hoisted_13 = {
  class: "homesolu"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "linetitlemiddle"
}, "产品中心", -1);
const _hoisted_15 = {
  class: "linesubtitle"
};
const _hoisted_16 = {
  class: "homesoluinfo"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "linkmoremiddle"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/product",
  class: "navmore"
}, "了解更多")], -1);
const _hoisted_19 = {
  class: "hometechwrap"
};
const _hoisted_20 = {
  class: "hometechbg"
};
const _hoisted_21 = {
  class: "hometech"
};
const _hoisted_22 = {
  class: "hometechbox"
};
const _hoisted_23 = {
  class: "hometechtop"
};
const _hoisted_24 = {
  class: "hometechtitle"
};
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "linetitleleft2"
}, "技术创新", -1);
const _hoisted_26 = {
  class: "linesubtitle2"
};
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "linkmoreright"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/news",
  class: "navmore2"
}, "了解更多")], -1);
const _hoisted_28 = {
  class: "hometechinfo"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "homenewswrap"
};
const _hoisted_31 = {
  class: "homenews"
};
const _hoisted_32 = {
  class: "homenewstop"
};
const _hoisted_33 = {
  class: "homenewstitle"
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "linetitleleft"
}, "企业动态", -1);
const _hoisted_35 = {
  class: "linesubtitle"
};
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "linkmoreright"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/news",
  class: "navmore"
}, "了解更多")], -1);
const _hoisted_37 = {
  class: "homenewsinfo"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  class: "homenewsinfoimg"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "imgmask"
}, null, -1);
const _hoisted_42 = {
  class: "overdot"
};
export default {
  __name: 'home',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const FFdata = reactive({
      isLoad: false,
      listNav: [],
      listTechImgs: [],
      listSoluImgs: [],
      listNews: [],
      //cNavIndex: 0,

      topTitle: ''
    });
    const getData = () => {
      proxy.$common.fetch({
        'act': 'sei_home',
        msg: ''
      }, res => {
        FFdata.listNav = res.infodata;
        FFdata.listTechImgs = res.infodatatechimgs;
        FFdata.listSoluImgs = res.infodatasoluimgs;
        FFdata.listNews = res.infodatanews;
        FFdata.isLoad = true;
      });
      proxy.$store.SET_NAVALIAS('');
    };
    const goUrl = id => {
      router.push('/news/' + id);
    };
    const navOver = index => {
      //FFdata.cNavIndex = index;
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_ffimg = _resolveComponent("ffimg");
      const _component_ffcontent = _resolveComponent("ffcontent");
      const _directive_title = _resolveDirective("title");
      return _unref(FFdata).isLoad ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_ffimg, {
        alias: "sei_homeimg"
      })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_ffimg, {
        alias: "sei_logosub"
      })]), _createElementVNode("dl", _hoisted_7, [_hoisted_8, _createElementVNode("dd", _hoisted_9, [_createVNode(_component_ffcontent, {
        alias: "sei_home_about_subtitle"
      })]), _createElementVNode("dd", _hoisted_10, [_createVNode(_component_ffcontent, {
        alias: "sei_home_about"
      })]), _hoisted_11])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_ffcontent, {
        alias: "sei_home_solu_subtitle"
      })]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listSoluImgs, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "homesoluimg",
          key: item.id
        }, [_createElementVNode("img", {
          src: item.imgs
        }, null, 8, _hoisted_17)]);
      }), 128))]), _hoisted_18])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_ffimg, {
        alias: "sei_home_techbg"
      })]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createVNode(_component_ffcontent, {
        alias: "sei_home_tech_subtitle"
      })])]), _hoisted_27]), _createElementVNode("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listTechImgs, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "hometechimg",
          key: item.id
        }, [_createElementVNode("img", {
          src: item.imgs
        }, null, 8, _hoisted_29)]);
      }), 128))])])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, [_createVNode(_component_ffcontent, {
        alias: "sei_home_news_subtitle"
      })])]), _hoisted_36]), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listNews, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "homenewsinfoitem",
          key: item.id,
          onClick: $event => goUrl(item.id)
        }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_40)]), _hoisted_41, _createElementVNode("dl", null, [_createElementVNode("dt", _hoisted_42, _toDisplayString(_ctx.$common.langInfo(item.title, item.title_en)), 1), _createElementVNode("dd", null, _toDisplayString(_ctx.$common.basic.dateFormat(item.datepublish)), 1)])], 8, _hoisted_38);
      }), 128))])])])])), [[_directive_title, _unref(FFdata).topTitle]]) : _createCommentVNode("", true);
    };
  }
};